/**
 * Shared Constants — single source of truth for ALL master data
 * Used by web + mobile
 */

// ─── Lead Status ──────────────────────────────────────────────────────────────
export const LEAD_STATUS = {
  UNDER_FOLLOWUP: 'Under Follow-up',
  CONVERTED:      'Converted',
  CLOSED:         'Closed',
};

// Conversion sub-stages (inside CONVERTED)
export const CONVERSION_STAGE = {
  LOGIN:      'Login',
  SANCTION:   'Sanction',
  DISBURSED:  'Disbursed',
  PDD_CLEARED:'PDD Cleared',
};

// ─── Products (exactly 14 as per SRS) ────────────────────────────────────────
export const PRODUCTS = [
  { id: 1,  code: 'HL_RESALE',       name: 'HL - Resale',         category: 'Home Loan' },
  { id: 2,  code: 'HL_CONSTRUCTION', name: 'HL - Construction',   category: 'Home Loan' },
  { id: 3,  code: 'HL_BT',           name: 'HL - BT',             category: 'Home Loan' },
  { id: 4,  code: 'TOP_UP',          name: 'Top Up',              category: 'Home Loan' },
  { id: 5,  code: 'NRP',             name: 'NRP',                 category: 'Home Loan' },
  { id: 6,  code: 'LAP',             name: 'LAP',                 category: 'Loan Against Property' },
  { id: 7,  code: 'EQUIPMENT_LOAN',  name: 'Equipment Loan',      category: 'Business' },
  { id: 8,  code: 'PERSONAL_LOAN',   name: 'Personal Loan',       category: 'Personal' },
  { id: 9,  code: 'BUSINESS_LOAN',   name: 'Business Loan',       category: 'Business' },
  { id: 10, code: 'EDUCATION_LOAN',  name: 'Education Loan',      category: 'Education' },
  { id: 11, code: 'CAR_LOAN',        name: 'Car Loan',            category: 'Vehicle' },
  { id: 12, code: 'GOLD_LOAN',       name: 'Gold Loan',           category: 'Secured' },
  { id: 13, code: 'SME_LOAN',        name: 'SME Loan',            category: 'Business' },
  { id: 14, code: 'CC_OD',           name: 'CC / OD',             category: 'Business' },
];

// ─── Lead Sources ─────────────────────────────────────────────────────────────
export const LEAD_SOURCE_TYPES = [
  { id: 'BSA',      label: 'BSA'           },   // shows BSA code dropdown
  { id: 'Direct',   label: 'Direct'        },
  { id: 'Internal', label: 'Internal'      },   // shows staff dropdown
];

// ─── Closure Reasons (as per SRS FR-7) ───────────────────────────────────────
export const CLOSURE_REASONS = [
  { id: 1, name: 'Lost to Competition' },
  { id: 2, name: 'Deal Called Off'     },
  { id: 3, name: 'Eligibility Issue'   },
  { id: 4, name: 'Legal'               },
  { id: 5, name: 'Technical'           },
  { id: 6, name: 'Credit'              },
];

// ─── Login Stage Types ────────────────────────────────────────────────────────
export const LOGIN_TYPES = [
  { id: 'With', label: 'With (Direct Bank/FI)' },
  { id: 'Thru', label: 'Thru (Channel/Platform)' },
];

// ─── Banks / FIs (70+ as per SRS) ────────────────────────────────────────────
export const BANKS = [
  // PSU Banks
  { id: 1,  name: 'State Bank of India (SBI)',    category: 'PSU Bank' },
  { id: 2,  name: 'Punjab National Bank (PNB)',   category: 'PSU Bank' },
  { id: 3,  name: 'Bank of Baroda',               category: 'PSU Bank' },
  { id: 4,  name: 'Canara Bank',                  category: 'PSU Bank' },
  { id: 5,  name: 'Union Bank of India',          category: 'PSU Bank' },
  { id: 6,  name: 'Bank of India',                category: 'PSU Bank' },
  { id: 7,  name: 'Central Bank of India',        category: 'PSU Bank' },
  { id: 8,  name: 'Indian Bank',                  category: 'PSU Bank' },
  { id: 9,  name: 'Indian Overseas Bank',         category: 'PSU Bank' },
  { id: 10, name: 'UCO Bank',                     category: 'PSU Bank' },
  { id: 11, name: 'Bank of Maharashtra',          category: 'PSU Bank' },
  { id: 12, name: 'Punjab & Sind Bank',           category: 'PSU Bank' },
  // Private Banks
  { id: 13, name: 'HDFC Bank',                    category: 'Private Bank' },
  { id: 14, name: 'ICICI Bank',                   category: 'Private Bank' },
  { id: 15, name: 'Axis Bank',                    category: 'Private Bank' },
  { id: 16, name: 'Kotak Mahindra Bank',          category: 'Private Bank' },
  { id: 17, name: 'IndusInd Bank',                category: 'Private Bank' },
  { id: 18, name: 'Yes Bank',                     category: 'Private Bank' },
  { id: 19, name: 'IDFC First Bank',              category: 'Private Bank' },
  { id: 20, name: 'Federal Bank',                 category: 'Private Bank' },
  { id: 21, name: 'South Indian Bank',            category: 'Private Bank' },
  { id: 22, name: 'Karur Vysya Bank',             category: 'Private Bank' },
  { id: 23, name: 'RBL Bank',                     category: 'Private Bank' },
  { id: 24, name: 'Bandhan Bank',                 category: 'Private Bank' },
  { id: 25, name: 'City Union Bank',              category: 'Private Bank' },
  { id: 26, name: 'Tamilnad Mercantile Bank',     category: 'Private Bank' },
  { id: 27, name: 'CSB Bank',                     category: 'Private Bank' },
  { id: 28, name: 'Jammu & Kashmir Bank',         category: 'Private Bank' },
  { id: 29, name: 'Karnataka Bank',               category: 'Private Bank' },
  { id: 30, name: 'DCB Bank',                     category: 'Private Bank' },
  // Small Finance Banks
  { id: 31, name: 'AU Small Finance Bank',        category: 'Small Finance Bank' },
  { id: 32, name: 'Ujjivan Small Finance Bank',   category: 'Small Finance Bank' },
  { id: 33, name: 'Equitas Small Finance Bank',   category: 'Small Finance Bank' },
  { id: 34, name: 'Jana Small Finance Bank',      category: 'Small Finance Bank' },
  { id: 35, name: 'ESAF Small Finance Bank',      category: 'Small Finance Bank' },
  { id: 36, name: 'Suryoday Small Finance Bank',  category: 'Small Finance Bank' },
  { id: 37, name: 'Utkarsh Small Finance Bank',   category: 'Small Finance Bank' },
  { id: 38, name: 'North East Small Finance Bank',category: 'Small Finance Bank' },
  { id: 39, name: 'Capital Small Finance Bank',   category: 'Small Finance Bank' },
  { id: 40, name: 'Shivalik Small Finance Bank',  category: 'Small Finance Bank' },
  // HFCs
  { id: 41, name: 'LIC Housing Finance',          category: 'HFC' },
  { id: 42, name: 'PNB Housing Finance',          category: 'HFC' },
  { id: 43, name: 'Indiabulls Housing Finance',   category: 'HFC' },
  { id: 44, name: 'Aavas Financiers',             category: 'HFC' },
  { id: 45, name: 'Home First Finance',           category: 'HFC' },
  { id: 46, name: 'Aptus Value Housing Finance',  category: 'HFC' },
  { id: 47, name: 'Shriram Housing Finance',      category: 'HFC' },
  { id: 48, name: 'Can Fin Homes',                category: 'HFC' },
  { id: 49, name: 'GIC Housing Finance',          category: 'HFC' },
  { id: 50, name: 'Repco Home Finance',           category: 'HFC' },
  // NBFCs
  { id: 51, name: 'Bajaj Finance',                category: 'NBFC' },
  { id: 52, name: 'Tata Capital',                 category: 'NBFC' },
  { id: 53, name: 'L&T Finance',                  category: 'NBFC' },
  { id: 54, name: 'Aditya Birla Finance',         category: 'NBFC' },
  { id: 55, name: 'Mahindra Finance',             category: 'NBFC' },
  { id: 56, name: 'Shriram Finance',              category: 'NBFC' },
  { id: 57, name: 'Cholamandalam Finance',        category: 'NBFC' },
  { id: 58, name: 'Muthoot Finance',              category: 'NBFC' },
  { id: 59, name: 'Manappuram Finance',           category: 'NBFC' },
  { id: 60, name: 'Piramal Capital & Housing',    category: 'NBFC' },
  { id: 61, name: 'Axis Finance',                 category: 'NBFC' },
  { id: 62, name: 'HDB Financial Services',       category: 'NBFC' },
  { id: 63, name: 'Fullerton India',              category: 'NBFC' },
  { id: 64, name: 'TVS Credit',                   category: 'NBFC' },
  { id: 65, name: 'Sundaram Finance',             category: 'NBFC' },
  { id: 66, name: 'Hero FinCorp',                 category: 'NBFC' },
  { id: 67, name: 'Godrej Capital',               category: 'NBFC' },
  { id: 68, name: 'IIFL Finance',                 category: 'NBFC' },
  { id: 69, name: 'Tata Motors Finance',          category: 'NBFC' },
  { id: 70, name: 'Lendingkart',                  category: 'NBFC' },
];

// ─── Channels (Thru) ──────────────────────────────────────────────────────────
// These come from backend master, but we seed defaults here
export const DEFAULT_CHANNELS = [
  { id: 1, name: 'Andro',        gstin: '', payout_percent: 0 },
  { id: 2, name: 'Ru Loans',     gstin: '', payout_percent: 0 },
  { id: 3, name: 'RKPL',         gstin: '', payout_percent: 0 },
  { id: 4, name: 'Basic',        gstin: '', payout_percent: 0 },
  { id: 5, name: 'Urban Money',  gstin: '', payout_percent: 0 },
  { id: 6, name: 'FA Wizard',    gstin: '', payout_percent: 0 },
  { id: 7, name: 'Car Dekho',    gstin: '', payout_percent: 0 },
  { id: 8, name: 'Paisa Bazaar', gstin: '', payout_percent: 0 },
];

// ─── Disbursement Types ───────────────────────────────────────────────────────
export const DISBURSEMENT_TYPES = [
  { id: 'Full',    label: 'Full Disbursement'    },
  { id: 'Partial', label: 'Partial Disbursement' },
];

// ─── User Roles ───────────────────────────────────────────────────────────────
export const USER_ROLES = {
  ADMIN:         'admin',
  SALES_MANAGER: 'sales_manager',
  SALES_USER:    'sales_user',
  FOS:           'fos',
  ACCOUNTANT:    'accountant',
};

export default {
  LEAD_STATUS,
  CONVERSION_STAGE,
  PRODUCTS,
  LEAD_SOURCE_TYPES,
  CLOSURE_REASONS,
  LOGIN_TYPES,
  BANKS,
  DEFAULT_CHANNELS,
  DISBURSEMENT_TYPES,
  USER_ROLES,
};
